import styled from 'styled-components';
import { FlexCenter } from '../../global/commonStyle';
import { Typography } from '../../global/theme';

const MarkdownContainer = styled.div`
  padding-inline: var(--space-24);
  &.tiptap > :last-child,
  &.tiptap > div > :last-child {
    margin-bottom: var(--space-24);
  }
  &.tiptap > :first-child,
  &.tiptap > div > :first-child {
    margin-top: var(--space-24);
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin: var(--space-16) var(--space-0);
    ${Typography.body_md};
  }

  th,
  td {
    border: 0.5px solid var(--border-primary);
    padding: var(--space-8) var(--space-12);
    text-align: left;
  }

  th {
    background-color: var(--background-muted);
    ${Typography.body_md_semibold};
  }

  tr:hover td {
    background-color: var(--background-secondary);
  }
`;

const ErrorContainer = styled.div`
  ${FlexCenter}
  height: 200px;
  ${Typography.body_xl_medium};
  color: var(--accent-error);
  text-align: center;
  padding: var(--space-20);
`;

export { ErrorContainer, MarkdownContainer };
